export default __webpack_public_path__ + "static/media/clientes-inac.04fa4bd1.svg";